
    import './styles.scoped.css';
    export default {
  "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_17w1n_9",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_17w1n_21",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_17w1n_24",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_17w1n_27",
  "sticky-scrollbar-offset": "awsui_sticky-scrollbar-offset_faqt8_17w1n_30",
  "is-visual-refresh": "awsui_is-visual-refresh_faqt8_17w1n_33"
};
  